// eslint-disable-next-line no-restricted-imports
import { setMakeSpecificLenders } from '@/context/display';
import { store } from '@/context/store';
import { EMatchingEngineLenders } from '@/partners/matchingEngineEnums';

export async function setInitialMakeSpecificLenders(
    partnerMakeLenders: {
        make: string;
        tierLenders: {
          lenders: EMatchingEngineLenders[];
          showLenderDetails: boolean;
        }[];
      }[],
): Promise<void> {    
    const makeSpecificLenders = partnerMakeLenders;


    const currentMakeSpecificLenders =
        store.getState().displayReducer.makeSpecificLenders;
    if (makeSpecificLenders !== currentMakeSpecificLenders) {
        store.dispatch(setMakeSpecificLenders(makeSpecificLenders));
    }
    console.log('makeSpecificLenders', store.getState());

}
